// Config for Rest Area table
export const restAreaConfig = {
    apiBase: "roads_rest_area",
    columns: [
        { key: "name", header: "Name" },
        { key: "latitude", header: "Latitude" },
        { key: "longitude", header: "Longitude" }
    ],
    extraFields: [],
    defaultValues: { name: "", latitude: "", longitude: "" }
};

// Config for Safe Parking table
export const safeParkingConfig = {
    apiBase: "roads_safe_parking",
    columns: [
        { key: "name", header: "Name" },
        { key: "latitude", header: "Latitude" },
        { key: "longitude", header: "Longitude" }
    ],
    extraFields: [],
    defaultValues: { name: "", latitude: "", longitude: "" }
};

// Config for Weigh-In Motion table
export const weighInMotionConfig = {
    apiBase: "roads_weigh_in_motion",
    columns: [
        { key: "name", header: "Name" },
        { key: "latitude", header: "Latitude" },
        { key: "longitude", header: "Longitude" }
    ],
    extraFields: [],
    defaultValues: { name: "", latitude: "", longitude: "" }
};

// Fuel types for alternative fuels
export const fuelTypes = [
    "Electricity light",
    "Electricity heavy",
    "Hydrogen",
    "Liquified methane"
];

// Config factory for Alternative Fuels tables
export const altFuelsConfig = (fuelType) => ({
    apiBase: "roads_alternative_fuels_points",
    columns: [
        { key: "name", header: "Name" },
        { key: "latitude", header: "Latitude" },
        { key: "longitude", header: "Longitude" }
    ],
    extraFields: [
        { name: "fuelType", type: "select", label: "Fuel Type", options: fuelTypes },
        { name: "capacity", type: "number", label: "Capacity" }
    ],
    defaultValues: { name: "", latitude: "", longitude: "", fuelType, capacity: "" },
    showFuelType: true
});